"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _user = require("@evdy/web-redux/dist/actions/dash/user");

var _utils = require("../lib/utils");

var _AppLinks = _interopRequireDefault(require("./shared/elements/AppLinks"));

require("../sass/components/pages/V4/PagesFooter.css");

var _dec, _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var logo = 'https://everdays-site.s3.amazonaws.com/partners/logo.svg';
var bucket = 'https://everdays-site.s3.amazonaws.com/core/footer';
var fbIcon = "".concat(bucket, "/footer-facebook-icon.svg");
var instagramIcon = "".concat(bucket, "/footer-instagram-icon.svg");
var twitterIcon = "".concat(bucket, "/footer-twitter-icon.svg");
var linkedInIcon = "".concat(bucket, "/footer-linkedIn-icon.svg");
var PagesFooter = (_dec = (0, _reactRedux.connect)(function (_ref) {
  var dash = _ref.dash;
  return {
    user: dash.user.data
  };
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(PagesFooter, _React$Component);

  var _super = _createSuper(PagesFooter);

  function PagesFooter(props) {
    var _this;

    _classCallCheck(this, PagesFooter);

    _this = _super.call(this, props);
    _this.handleAuthModal = _this.handleAuthModal.bind(_assertThisInitialized(_this));
    _this.handleSignOut = _this.handleSignOut.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PagesFooter, [{
    key: "handleAuthModal",
    value: function handleAuthModal(e, type) {
      var _this$props = this.props,
          pathname = _this$props.pathname,
          _this$props$queryStri = _this$props.queryString,
          queryString = _this$props$queryStri === void 0 ? '' : _this$props$queryStri;
      var path = pathname === '/' ? '' : pathname;
      var memorialURL = "".concat(path, "/").concat(type).concat(queryString);

      _reactRouter.browserHistory.push(memorialURL);
    }
  }, {
    key: "handleSignOut",
    value: function handleSignOut() {
      var dispatch = this.props.dispatch;
      dispatch((0, _user.signOut)('/invite'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          currentPage = _this$props2.currentPage,
          user = _this$props2.user,
          _this$props2$showAuth = _this$props2.showAuthLinks,
          showAuthLinks = _this$props2$showAuth === void 0 ? true : _this$props2$showAuth;
      var currentYear = new Date().getFullYear();
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "pages-footer"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "footer-links"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "logo-wrapper",
        href: "/"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: logo,
        alt: ""
      })), /*#__PURE__*/_react.default.createElement("ul", {
        className: "professional-links"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "links-title"
      }, "More Info"), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        id: "".concat(currentPage, "_footer_premium_professional"),
        href: "https://partners.everdays.com"
      }, "For Providers")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        id: "".concat(currentPage, "_footer_funeral_whensomeonedies"),
        href: "https://everdays.com/blog/"
      }, "Our Blog"))), /*#__PURE__*/_react.default.createElement("ul", {
        className: "everdays-links"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "links-title"
      }, "Everdays"), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        id: "".concat(currentPage, "_footer_contact"),
        href: "mailto:hello@everdays.com"
      }, "Contact Us")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        id: "".concat(currentPage, "_footer_help"),
        href: "https://help.everdays.com"
      }, "FAQs")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        id: "".concat(currentPage, "_footer_press"),
        href: "https://learn.everdays.com/about",
        rel: "noopener noreferrer"
      }, "About Us")))), /*#__PURE__*/_react.default.createElement("div", {
        className: "links-downloads-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "socials-wrapper"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "https://www.facebook.com/JoinEverdays/"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "social-icon"
      }, /*#__PURE__*/_react.default.createElement("img", {
        id: "".concat(currentPage, "_footer_facebook"),
        src: fbIcon,
        alt: ""
      }))), /*#__PURE__*/_react.default.createElement("a", {
        href: "https://www.linkedin.com/company/everdays-inc./"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "social-icon"
      }, /*#__PURE__*/_react.default.createElement("img", {
        id: "".concat(currentPage, "_footer_linkedin"),
        src: linkedInIcon,
        alt: ""
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "download-links"
      }, /*#__PURE__*/_react.default.createElement(_AppLinks.default, {
        currentPage: currentPage,
        isRow: true
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "legal-section"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "legal-wrapper"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "legal"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "sub-legal"
      }, "\xA9 ", currentYear, " Everdays, Inc. All rights reserved."), /*#__PURE__*/_react.default.createElement("p", {
        className: "sub-legal"
      }, "The Everdays mark and the Everdays logo are registered trademarks of Everdays, Inc.")), /*#__PURE__*/_react.default.createElement("div", {
        className: "terms-privacy-wrapper"
      }, /*#__PURE__*/_react.default.createElement("a", {
        id: "".concat(currentPage, "_footer_tos"),
        href: "/terms"
      }, "Terms of Service"), /*#__PURE__*/_react.default.createElement("a", {
        id: "".concat(currentPage, "_footer_privacy_policy"),
        href: "/privacy"
      }, "Privacy Policy"))), /*#__PURE__*/_react.default.createElement("p", {
        className: "sub-legal-footnote"
      }, "* This app is owned and operated by Everdays, Inc., a Delaware corporation doing business in California as Everdays Moments Insurance Marketing.")));
    }
  }]);

  return PagesFooter;
}(_react.default.Component)) || _class);
exports.default = PagesFooter;